<template>
  <span>
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[ { name: '面接情報', pathName: 'interviewInformationTop' }]"
        :title="`面接情報_${title}確認`"
      />
      <span
        class="text-center margin-top-1"
        data-test="notification"
      >
        <div>まだ完了しておりません。</div>
        <div>
          内容をご確認の上「登録する」ボタンを押してください。
        </div>
      </span>
      <div class="boss-scout-send-container">
        <form-label
          class-name="pega-form-label-importance"
          label="登録名"
        >
          <template #body>
            <div data-test="name">{{ jobInterview.name }}</div>
          </template>
        </form-label>
        <form-label
          class-name="pega-form-label-importance"
          label="求人設定"
        >
          <template #body>
            <div
              v-for="(job, i) in selectedJobs"
              :key="`job-${job.jobId}`"
            >
              <span :data-test="`job-${i}`">
                {{ job.jobAdministrationName }}（ {{ job.jobName }} ）
              </span>
            </div>
          </template>
        </form-label>
      </div>
      <!-- ▼概要▼ -->
      <div
        class="boss-joboffer-title boss-setting margin-top-2"
        data-test="interview-information-title"
      >
        概要
      </div>
      <div class="boss-scout-send-container">
        <form-label label="書類選考の有無">
          <template #body>
            <div data-test="paper-screening">{{ paperScreeningLabel }}</div>
            <span
              class="pega-pre-wrap"
              data-test="paper-screening-remarks"
            >{{ jobInterview.paperScreeningRemarks }}</span>
          </template>
        </form-label>
        <form-label label="適性検査の有無">
          <template #body>
            <div data-test="spi-test">{{ spiLabel }}</div>
            <span
              class="pega-pre-wrap"
              data-test="spi-test-remarks"
            >{{ jobInterview.spiTestRemarks }}</span>
          </template>
        </form-label>
        <form-label
          class-name="pega-pre-wrap"
          :label="`応募する方への\nメッセージ`"
        >
          <template #body>
            <div
              class="pega-pre-wrap"
              data-test="message"
            >{{ jobInterview.message }}</div>
          </template>
        </form-label>
      </div>
    </div>
    <!-- ▲概要▲ -->
    <!-- ▼詳細▼ -->
    <div class="boss-main-wrap boss-main-content-wrap pega-interview-detail-background margin-top-2 padding-bottom-3">
      <div
        class="boss-joboffer-title boss-setting margin-top-1"
        data-test="interview-detail-title"
      >
        詳細
      </div>
      <div>
        応募者のみに表示されます。
      </div>
      <div class="boss-scout-send-container boss-bgcolor-white">
        <div class="grid-x grid-padding-x  pega-form pega-interview-form">
          <div class="medium-3 cell  pega-pd-15  pega-interview-form-label">
            <span>面接の選考情報</span>
          </div>
          <div class="cell auto">
            <form-label
              class-name="pega-form-label-interview"
              label="面接内容"
            >
              <template #body>
                <div
                  class="pega-pre-wrap"
                  data-test="content"
                >{{ jobInterview.content }}</div>
              </template>
            </form-label>
            <div class="grid-x grid-padding-x grid-padding-y pega-form pega-interview-form-top-none">
              <div
                class="medium-3 cell pega-form-label pega-form-label-interview-top"
                data-test="form-label"
              >
                <span>面接官について</span>
              </div>
              <div class="auto cell padding-top-0 padding-left-0 padding-right-0 interview-form-top-none">
                <div
                  v-for="(interviewer, i) in jobInterview.interviewers"
                  :key="`interviewer-${interviewer.no}`"
                  class="pega-interviewer-wrap"
                >
                  <div class="pega-mb-05">
                    <span
                      class="boss-bgcolor-white-gray pega-selection-label"
                      :data-test="`selection-no-label-${i}`"
                    >{{ i + 1 }}次選考</span>
                  </div>
                  <div
                    :data-test="`interviewer-label-${i}`"
                  >{{ getInterviewLabel(interviewer) }}</div>
                  <span
                    class="pega-pre-wrap"
                    :data-test="`interviewer-remarks-${i}`"
                  >{{ interviewer.remarksOrFreeText }}</span>
                </div>
              </div>
            </div>
            <form-label class-name="pega-form-label-interview">
              <template #label>
                <span>所要時間<small>（任意）</small></span>
              </template>
              <template #body>
                <div data-test="required-time">{{ requiredTimeLabel }}</div>
                <span
                  class="pega-pre-wrap"
                  data-test="required-time-remarks"
                >{{ jobInterview.requiredTimeRemarks }}</span>
              </template>
            </form-label>
            <form-label
              class-name="pega-form-label-interview"
              form-class-name="pega-interview-form-bottom-none"
            >
              <template #label>
                <span>面接時の服装／持ち物<small>（任意）</small></span>
              </template>
              <template #body>
                <div data-test="cloth">{{ clothLabel }}</div>
                <span
                  class="pega-pre-wrap"
                  data-test="cloth-remarks"
                >{{ jobInterview.clothRemarks }}</span>
              </template>
            </form-label>
          </div>
        </div>
        <div class="grid-x grid-padding-x  pega-form pega-interview-form">
          <div class="medium-3 cell  pega-pd-15  pega-interview-form-label">
            <span>重視するポイント<br>
              <small>「★」が多いほど重視するポイントとなります。</small></span>
          </div>
          <div class="cell auto">
            <form-item-rating
              :rating="jobInterview.businessManner"
              label="ビジネスマナー"
              :read-only="true"
              form-label-class-name="pega-form-label-interview"
            />
            <form-item-rating
              :rating="jobInterview.communicationAbility"
              label="コミュニケーション能力"
              :read-only="true"
              form-label-class-name="pega-form-label-interview"
            />
            <form-item-rating
              :rating="jobInterview.skill"
              label="過去の経験・スキル"
              :read-only="true"
              form-label-class-name="pega-form-label-interview"
            />
            <form-item-rating
              :rating="jobInterview.motivation"
              label="やる気"
              :read-only="true"
              form-label-class-name="pega-form-label-interview"
              form-class-name="pega-interview-form-bottom-none"
            />
          </div>
        </div>
        <div class="grid-x grid-padding-x  pega-form pega-interview-form">
          <div class="medium-3 cell  pega-pd-15  pega-interview-form-label pega-interview-form-label-bottom">
            <span>中途面接について</span>
          </div>
          <div class="cell auto">
            <form-label class-name="pega-form-label-interview">
              <template #label>
                <span>過去の質問例１</span>
              </template>
              <template #body>
                <div
                  class="pega-pre-wrap"
                  data-test="question1"
                >{{ jobInterview.question1 }}</div>
              </template>
            </form-label>
            <form-label class-name="pega-form-label-interview">
              <template #label>
                <span>過去の質問例２<small>（任意）</small></span>
              </template>
              <template #body>
                <div
                  class="pega-pre-wrap"
                  data-test="question2"
                >{{ jobInterview.question2 }}</div>
              </template>
            </form-label>
            <form-label class-name="pega-form-label-interview">
              <template #label>
                <span>過去の質問例３<small>（任意）</small></span>
              </template>
              <template #body>
                <div
                  class="pega-pre-wrap"
                  data-test="question3"
                >{{ jobInterview.question3 }}</div>
              </template>
            </form-label>
            <form-label class-name="pega-form-label-interview">
              <template #label>
                <span>歓迎する質問<small>（任意）</small></span>
              </template>
              <template #body>
                <div
                  v-for="(question) in welcomQuestionLabels"
                  :key="`question-${question.id}`"
                >
                  <span data-test="welcome-quesetions">{{ question.name }}</span>
                </div>
              </template>
            </form-label>
          </div>
        </div>
      </div>
    </div>
    <!-- ▲詳細▲ -->

    <!-- ▼ボタン▼ -->
    <div class="boss-button-container">
      <button
        class="boss-button boss-button-return"
        type="button"
        data-test="button-back"
        @click="$emit('back')"
      ><span class="boss-button-return-text">戻る</span></button>
      <button
        class="boss-button-center boss-button-confirm"
        type="button"
        data-test="button-submit"
        @click="$emit('submitted')"
      ><span class="boss-button-confirm-text">この内容で登録する</span></button>
    </div>
    <!-- ▲ボタン▲ -->
  </span>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import { jobInterview } from '@/lib/labelValueMappings'
import FormLabel from '@/components/atoms/FormLabel.vue'
import FormItemRating from '@/components/atoms/FormItemRating.vue'

export default {
  components: {
    SettingHeader,
    FormLabel,
    FormItemRating
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    jobInterview: {
      type: Object,
      required: true
    },
    publishedJobs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      interviewOptions: jobInterview
    }
  },
  computed: {
    title () {
      return this.isEdit ? '編集' : '登録'
    },
    selectedJobs () {
      return this.publishedJobs.filter(publishedJob => this.jobInterview.jobs.indexOf(publishedJob.jobId) !== -1)
    },
    paperScreeningLabel () {
      return this.getLabel(this.jobInterview.paperScreening.id, this.interviewOptions.paperScreenings)
    },
    spiLabel () {
      return this.getLabel(this.jobInterview.spiTest.id, this.interviewOptions.spiTests)
    },
    requiredTimeLabel () {
      return this.getLabel(this.jobInterview.requiredTime.id, this.interviewOptions.requiredTimes)
    },
    clothLabel () {
      return this.getLabel(this.jobInterview.cloth.id, this.interviewOptions.clothes)
    },
    welcomQuestionLabels () {
      return this.interviewOptions.welcomeQuestionsOptions.filter(option => this.jobInterview.welcomeQuestions.indexOf(option.id) !== -1)
    }
  },
  methods: {
    getLabel (id, masters) {
      // 値がlabelValueMappingにない場合は空
      const selected = masters.filter(e => e.id === id)[0]
      return selected == null ? '' : selected.name
    },
    getInterviewLabel (val) {
      return val.selectionType.id !== 1 ? ''
        : `${this.getLabel(val.gender.id, this.interviewOptions.genders)}／${this.getLabel(val.position.id, this.interviewOptions.positions)}／${this.getLabel(val.generation.id, this.interviewOptions.generations)}`
    }
  }
}
</script>
